import { Card, CardContent } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import TestInfoCard from '../../../../components/TestInfoCard';
import palette from '../../../../theme/palette';
import NameAndChangeToScreenCard from '../../../../components/NameAndChangeToScreenCard';
import '../../../../css/upcomingTest.css';
import PageIcon from '../../../../svg/PageIcon';
import Header from '../../../../components/Header';
import DownloadFileContainer from '../../../../components/DownloadFileContainer';
import MySolution from './Student.MySolution';

export default function PreviousAssignmentDetails({ asgnDetails, onBack }) {
  const { name, createdAt, endDateTime, fileURL } = asgnDetails;
  const [selectedScreen, setSelScreen] = useState(null);
  return (
    <div style={{ marginTop: 20 }}>
      {/* eslint-disable-next-line */}
      {selectedScreen === null ? (
        <>
          <Header title={name} onBack={onBack} />
          <Card style={{ marginTop: 15 }}>
            <CardContent>
              <DownloadFileContainer title={fileURL} />
            </CardContent>
          </Card>
          <TestInfoCard
            createdOn={moment(createdAt).format('DD MMM, LT')}
            submissionDate={moment(endDateTime).format('DD MMM, LT')}
          />
          <Card style={{ marginTop: 25 }}>
            <CardContent>
              <NameAndChangeToScreenCard
                title="My Solution"
                // subTitle={date}
                isStudent
                // TODO: when we got marks from api then we have to display here
                // markedDone={markedDone}
                // testMark={testMark}
                // totalMark={totalMark}
                icon={<PageIcon color={palette.secondary.main} />}
                onClick={() => setSelScreen('solution')}
              />
            </CardContent>
          </Card>
        </>
      ) : (
        selectedScreen === 'solution' && (
          <MySolution onBack={() => setSelScreen(null)} asgnDetails={asgnDetails} />
        )
      )}
    </div>
  );
}

PreviousAssignmentDetails.propTypes = {
  asgnDetails: PropTypes.object,
  onBack: PropTypes.func
};
